import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function AddClient(data) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client', {
            method: 'post',
            headers: { 'Authorization' : unHashedJwt.data},
            data: {
                "clientName": data.naziv.trim(),
                "clientFullAddress": data.adresa.trim(),
                "contactPhoneNumber": data.telefon.trim(),
                "contactEmail": data.email.trim(),
                "clientVatNumber": data.oib.trim(),
                "clientCountrySpecificVatNumber": data.oib.trim(),
                "countryUuid": data.countryUuid.trim(),
                "clientTypeUuid": data.clientTypeUuid.trim(),
                "domainLabel": data.domainName.trim(),
                "inVatSystem": data.pdv
            }      
        }).then(res => res)
        .catch(error => error.response),
        "Admin"
        );
}